import { GridRowSelectionModel } from '@mui/x-data-grid';
import { Booking, BookingState } from '@thro-types/leihbar';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useBookingMutation } from 'api/hooks/leihbar';
import { translations } from 'locales/i18n';

import { BookingDatagrid } from '../../components/BookingDatagrid';
import { BookingStateApplyButton } from '../../components/BookingStateApplyButton';
import { TabPanels } from '../OrderDetail';

interface Props {
  bookings: Booking[];
  selected: GridRowSelectionModel;
  handleSelect: (selected: GridRowSelectionModel) => void;
}
export const Pickup = ({ bookings, selected, handleSelect }: Props) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { setState } = useBookingMutation();

  const handleCollection = async () => {
    await setState.mutateAsync({
      state: BookingState.COLLECTED,
      orderId: Number(id),
      bookingIds: selected.map(id => Number(id))
    });
    handleSelect([]);
  };

  return (
    <>
      <BookingDatagrid
        bookings={bookings || []}
        selected={selected}
        handleSelect={handleSelect}
        tab={TabPanels.PICKUP}
      />
      <BookingStateApplyButton
        onClick={handleCollection}
        disabled={!selected.length}
        label={t(translations.pages.leihbar.daily.buttonLabels.approveCollection())}
      />
    </>
  );
};
